import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocalStorage from '../../../services/LocalStorage';
import Toast from '../../shared/toast';
import { ToastType } from '../../shared/toast/interface';

export const RECOMMENDATION_EMPTY_BOX = 'RECOMMENDATION_EMPTY_BOX';

const RecommendationEmpty = () => {
  const { t } = useTranslation();
  const [showNoRecommendationBox, setShowNoRecommendationBox] = useState(true);

  const onDissmissRecommendationToast = () => {
    LocalStorage.setItem(RECOMMENDATION_EMPTY_BOX, new Date().toDateString());
    setShowNoRecommendationBox(false);
  };

  return showNoRecommendationBox ? (
    <Toast
      type={ToastType.INFO}
      showToast={showNoRecommendationBox}
      text={t('v2.dashboard.recommendations_alert_label_body_noMatch')}
      onDismiss={() => onDissmissRecommendationToast()}
    />
  ) : null;
};

export default RecommendationEmpty;
